<div class="sticker-dialog">
  <div class="ui-g-12 p-zero dialog-header m-0 d-flex align-items-center">
    <i class="far fa-tools font-20 font-gray-45 header-icon"></i>
    <div class="send-dialog-heading capitalize">Oil change sticker</div>
    <i class="far fa-times fa-sm dialog-close" (click)="close()"></i>
  </div>
  <div class="ui-g-12 dialog-body sticker-inner-body pt-3">
    <!-- Basic info section -->
    <div class="input-pricing-info-wrapper input-default-style ui-g-12 p-0 mb-20p">
      <h5 class="input-heading">Basic Info</h5>

      <div class="ui-g-12 p-0">
        <!-- Vehicle info -->
        <div class="ui-g-6 p-0 flex-start-center input-control-container mt-2">
          <div class="icon flex-center-start">
            <i class="far fa-car height-icon"></i>
          </div>

          <div class="width-100p pl-2 pr-2">
            <app-input id="sticker-vehicle" type="text" placeholder="Vehicle" label="Vehicle" [disabled]="true"
              [floatingLabel]="true" [fontSize]="14" theme="light" name="actualLaborTime" [maxLength]="50"
              [selectTextOnFocus]="true" [value]="vehicleYmm">
            </app-input>
          </div>
        </div>

        <div class="ui-g-6 p-0 flex-start-center input-control-container mt-2">
          <div class="icon flex-center-start">
            <i class="far fa-tachometer height-icon"></i>
          </div>

          <div class="width-100p pl-2">
            <app-input id="sticker-vehicle" type="text" [label]="'Current Odometer ' + measuringUnitOnly"
              placeholder="Current Odometer" theme="light" name="price" [fontSize]="14" [disabled]="true"
              [floatingLabel]="true" [value]="odoMeter">
            </app-input>
          </div>
        </div>
      </div>
    </div>
    <!-- Basic info section ends-->

    <!-- Preselect - stripe -->
    <div class="input-pricing-info-wrapper input-default-style ui-g-12 p-0 mb-20p">
      <div class="ui-g-12 p-0">
        <ul class="oil-change-pill-wrapper">
          <li class="oil-change-pill" [class.active]="i === activePillIndex"
            *ngFor="let oilChange of oilChangePills; let i = index" (click)="onOilChangePillClick(i)">
            <span class="oil-change-mileage">
              {{oilChange.label}}
              {{(measuringUnitOnly === 'km' ? oilChange.km : oilChange.mi) | number:'1.0'}}
              {{measuringUnitOnly}}
            </span>
          </li>
        </ul>
      </div>
    </div>

    <!-- Next Service due info section -->
    <div class="input-pricing-info-wrapper input-default-style ui-g-12 p-0 mb-20p">
      <h5 class="input-heading">Next Service due</h5>

      <div class="ui-g-12 p-0">
        <!-- Next Service due -->
        <div class="ui-g-6 p-0 flex-start-center input-control-container mt-2 sticker-input"
          (click)="activePillIndex = 0 || paymentDateTimeEl.showOverlay()">
          <div class="icon flex-center-start">
            <i class="far fa-calendar-alt height-icon"></i>
          </div>

          <div class="width-100p pl-2 pr-2 position-relative">
            <label for="Date" class="calendar-label">Date</label>
            <p-calendar id="payment-date" placeholder="Date" styleClass="payment-pointer"
              panelStyleClass="sticker-calendar-panel" [(ngModel)]="date" [readonlyInput]="true" [minDate]="min"
              dateFormat="M d, yy" appendTo="body" #paymentDateTimeEl></p-calendar>
          </div>
        </div>

        <div class="ui-g-6 p-0 flex-start-center input-control-container mt-2 error-spacing">
          <div class="icon flex-center-start">
            <i class="far fa-tachometer height-icon"></i>
          </div>

          <div class="width-100p pl-2">
            <app-input id="sticker-vehicle" placeholder="Please enter miles" theme="light" name="nextServiceMiles"
              [allowDecimal]="true" [maxLength]="10" [errorMessage]="fieldErrors.bin" [isInvalid]="!!fieldErrors.bin"
              [label]="measuringLabel" [fontSize]="14" [floatingLabel]="true" [value]="nextServiceMiles"
              (appChange)="handleChange('nextServiceMiles', $event)">
            </app-input>
          </div>
        </div>
      </div>
    </div>
    <!-- Next Service due section ends-->

    <!-- Next Service due info section -->
    <div hidden class="input-pricing-info-wrapper input-default-style ui-g-12 p-0 mb-20p">
      <h5 class="input-heading font-12 font-normal">Filter Change</h5>

      <div class="ui-g-12 p-0">
        <!-- Next Service due -->
        <div class="ui-g-6 p-0 flex-start-center input-control-container filter-change">
          <div class="flex-start-center label-12 infield-radio-button">
            <span class="pr-5 radio-inline">
              <app-radio-button name="filterChange" label="Yes" [selectedValue]="isFilterChange" [value]="true"
                (appChange)="isFilterChange = $event"> </app-radio-button>
            </span>

            <span class="pr-1">
              <app-radio-button name="filterChange" label="No" [selectedValue]="isFilterChange" [value]="false"
                (appChange)="isFilterChange = $event"> </app-radio-button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- Next Service due section ends-->
  </div>
  <div class="ui-g-12 p-zero dialog-footer text-right">
    <button class="btn btn-border pointer btn-submit mr-2" id="btn-cancel-sticker" (click)="close()">Cancel</button>
    <button class="btn btn-primary btn-submit" id="btn-print-sticker" (click)="printOilSticker()">Print sticker</button>
  </div>
</div>
